// extracted by mini-css-extract-plugin
export default {"melodyVideo":"lP-z","isFullWidth":"mP-z","landingPageVideo":"nP-z","play":"oP-z","iframeVideo":"pP-z","playHidden":"qP-z","fullwidth":"rP-z"};